import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-hotel-stars',
  templateUrl: environment.mobile ? './hotel-stars.component.mobile.html' : './hotel-stars.component.html',
  styleUrls: environment.mobile ? ['./hotel-stars.component.mobile.scss'] : ['./hotel-stars.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class HotelStarsComponent implements OnInit {
  isStars = true;
  private starsValue;

  @Input()
  set value(stars: any) {
    this.starsValue = stars;
    this.populateStars();
    this.cd.markForCheck();
  }

  get value() {
    return this.starsValue;
  }

  stars: boolean[] = [false, false, false, false, false];

  constructor(public cd: ChangeDetectorRef) {}

  ngOnInit() {}

  private populateStars() {
    const value = Number(this.value);
    // value !== 0 нужен тогда, когда нам приходит звездность ''
    // Number('') === 0
    if (!Number.isNaN(value) && value !== 0) {
      this.stars = [false, false, false, false, false];
      this.isStars = true;
      for (let index = 0; index < value && index < 5; index++) {
        this.stars[index] = true;
      }
    } else {
      this.isStars = false;
    }
  }
}
